var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgJs = function SvgJs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EDEEEF",
    d: "M6.1 0c-.825 0-1.5.675-1.5 1.5v21c0 .825.675 1.5 1.5 1.5h15c.825 0 1.5-.675 1.5-1.5V6l-6-6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B0B7BD",
    d: "M18.1 6h4.5l-6-6v4.5c0 .825.675 1.5 1.5 1.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#CAD1D8",
    d: "M22.6 10.5 18.1 6h4.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#576D7E",
    d: "M19.6 19.5c0 .413-.338.75-.75.75H2.35a.75.75 0 0 1-.75-.75V12c0-.412.337-.75.75-.75h16.5c.412 0 .75.338.75.75z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.182 14.21c0-.504.792-.504.792 0v2.369c0 .941-.45 1.511-1.487 1.511-.51 0-.936-.139-1.307-.617-.306-.366.27-.893.581-.51.252.312.522.384.786.371.336-.012.63-.162.636-.755zM10.894 14.75c.138-1.164 1.895-1.373 2.723-.737.407.33-.025.851-.385.587-.443-.282-1.45-.414-1.577.21-.162.983 2.447.42 2.405 2.015-.042 1.523-2.249 1.559-3.077.875a.443.443 0 0 1-.084-.587c.156-.155.33-.21.534-.042.492.336 1.758.588 1.848-.265-.079-.887-2.573-.353-2.387-2.057"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#CAD1D8",
    d: "M18.85 20.25H4.6V21h14.25c.412 0 .75-.337.75-.75v-.75c0 .413-.338.75-.75.75"
  })));
};
export default SvgJs;